import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "./AsyncComponent";
import { Context } from "./Context";
const Content = asyncComponent(() => import("../content/index"));
const EccDetail = asyncComponent(() => import("../ecc/detail"));
const EccList = asyncComponent(() => import("../ecc/index"));
const EventDetail = asyncComponent(() => import("../event/detail"));
const EventList = asyncComponent(() => import("../event/index"));
const Login = asyncComponent(() => import("./Login"));
const MediaCorner = asyncComponent(() => import("../mediaCorner/index"));
const MediaCornerDetail = asyncComponent(() => import("../mediaCorner/detail"));
const NewUserPassword = asyncComponent(() => import("./NewUserPassword"));
const NotFound = asyncComponent(() => import("./NotFound"));
const OfficeDetail = asyncComponent(() => import("../office/index"));
const TranslationGrid = asyncComponent(() => import("../translation/index"));
const UrbanStoriesDetail = asyncComponent(() =>
  import("../urbanStories/detail"),
);
const UrbanStoriesList = asyncComponent(() => import("../urbanStories/index"));
const User = asyncComponent(() => import("../user/index"));
const UserDetail = asyncComponent(() => import("../user/detail"));
const ViennaDaysDetail = asyncComponent(() => import("../viennaDays/detail"));
const ViennaDaysList = asyncComponent(() => import("../viennaDays/index"));
const ViennaScienceDaysDetail = asyncComponent(() =>
  import("../viennaScienceDays/detail"),
);
const ViennaScienceDaysList = asyncComponent(() =>
  import("../viennaScienceDays/index"),
);
const ViennaConnectDetail = asyncComponent(() =>
  import("../viennaConnect/detail"),
);
const ViennaConnectList = asyncComponent(() =>
  import("../viennaConnect/index"),
);
class Routes extends Component {
  render() {
    return (
      <Context.Consumer>
        {({ user }) => (
          <div id="content">
            <Switch>
              <Route
                path="/"
                exact={true}
                render={(props) => {
                  if (!user || !user.isLoggedIn)
                    return (
                      <Redirect
                        to={{
                          pathname: "/Login",
                          state: { from: props.location },
                        }}
                      />
                    );

                  var redirectPath;
                  if (user.rolesVisible && user.rolesVisible.length)
                    redirectPath = user.rolesVisible[0].url;
                  if (!redirectPath || redirectPath === "")
                    redirectPath = "/Inhalte";
                  return <Redirect to={redirectPath} />;
                }}
              />

              <AuthenticatedRoute
                component={Content}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Inhalte"
              />
              <AuthenticatedRoute
                component={Content}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Inhalte/:id"
              />
              <AuthenticatedRoute
                component={EccList}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/ECC"
              />
              <AuthenticatedRoute
                component={EccDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/ECC/:id"
              />
              <AuthenticatedRoute
                component={EventList}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Veranstaltungen"
              />
              <AuthenticatedRoute
                component={EventDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Veranstaltungen/:id"
              />
              <AuthenticatedRoute
                component={MediaCorner}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/MediaCorner"
              />
              <AuthenticatedRoute
                component={MediaCornerDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/MediaCorner/:id"
              />
              <AuthenticatedRoute
                component={MediaCornerDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/MediaCorner/:forceType/:id"
              />
              <AuthenticatedRoute
                component={OfficeDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Auslandsbueros"
              />
              <AuthenticatedRoute
                component={TranslationGrid}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Uebersetzungen"
              />
              <AuthenticatedRoute
                component={UrbanStoriesList}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/UrbanStories"
              />
              <AuthenticatedRoute
                component={UrbanStoriesDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/UrbanStories/:id"
              />
              <AuthenticatedRoute
                component={User}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Benutzer"
              />
              <AuthenticatedRoute
                component={UserDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/Benutzer/:id"
              />
              <AuthenticatedRoute
                component={ViennaDaysList}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/WienTage"
              />
              <AuthenticatedRoute
                component={ViennaDaysDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/WienTage/:id"
              />
              <AuthenticatedRoute
                component={ViennaScienceDaysList}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/ViennaScienceDays"
              />
              <AuthenticatedRoute
                component={ViennaScienceDaysDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/ViennaScienceDays/:id"
              />
              <AuthenticatedRoute
                component={ViennaConnectList}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/ViennaConnect"
              />
              <AuthenticatedRoute
                component={ViennaConnectDetail}
                exact={true}
                isLoggedIn={user.isLoggedIn}
                path="/ViennaConnect/:id"
              />
              <Route component={Login} path="/Login" />
              <Route component={NewUserPassword} path="/Passwort/:key" />
              <AuthenticatedRoute
                isLoggedIn={user.isLoggedIn}
                component={NotFound}
              />
            </Switch>
          </div>
        )}
      </Context.Consumer>
    );
  }
}

const AuthenticatedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      rest.isLoggedIn === true ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/Login",
            state: {
              from: props.location,
            },
          }}
        />
      )
    }
  />
);

export default Routes;
